import { CardAccountDetailsIcon } from './CardAccountDetailsIcon';

/**
 * author: Christopher Schreiner
 * id 4ACD18FB-87D4-46F1-9231-8BD0A91867A9
 * name card-account-details
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-details.svg
 * tags
 * - Account / User 
 */
export const DriversLicenseIcon = CardAccountDetailsIcon;
export default DriversLicenseIcon